import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import './sliderCard.scss';
import { changeRef, getTarget } from '../../../utils/location';
import { getAssetUrl } from '@/utils/contentFullAsset';

interface CoverPageInterface {
  coverpage: {
    redireccion: string;
    icono: {
      file: {
        url: string;
      };
      title: string;
    };
    titulo: string;
    descripcion: any;
  };
}

const SliderCard = (props: CoverPageInterface) => {
  const { coverpage } = props;

  return (
    <a
      className="a-coverp"
      href={changeRef(coverpage.redireccion)}
      target={getTarget(coverpage.redireccion)}
      rel="noopener noreferrer"
    >
      <div className="a-coverp__content">
        <img
          src={coverpage.icono && getAssetUrl(coverpage.icono)}
          alt={coverpage.icono && coverpage.icono.title}
        />
        <div className="a-coverp__content__description">
          <h1>{coverpage.titulo}</h1>
          <div>
            {coverpage?.descripcion?.raw &&
              documentToReactComponents(JSON.parse(coverpage?.descripcion?.raw))}
          </div>
        </div>
      </div>
    </a>
  );
};

export default SliderCard;
